export default __webpack_public_path__ + "static/media/DISS-CO-Letter_of_Attestation_en.6323ee71.pdf";